export const ColorFormats = Object.freeze({
    hex: Symbol("hex"),
    hsl: Symbol("hsl"),
    rgb: Symbol("rgb"),
});
